module.exports = "/_next/static/images/93017e4a6d3b252e92c218c86ead4807-cards-left-small.jpg.webp";